'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentsAuditLogListResponseItem(organizationId, organization, user, action, at) {
  this.Xk = null;
  this.Kt = null;
  this.Xl = null;
  this.EO = null;
  this.Ks = null;
  this.Xk = organizationId;
  this.Kt = organization;
  this.Xl = user;
  this.EO = action;
  this.Ks = at;
}
export { $c_Lapp_api_DocumentsAuditLogListResponseItem as $c_Lapp_api_DocumentsAuditLogListResponseItem };
$p = $c_Lapp_api_DocumentsAuditLogListResponseItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentsAuditLogListResponseItem;
/** @constructor */
function $h_Lapp_api_DocumentsAuditLogListResponseItem() {
}
export { $h_Lapp_api_DocumentsAuditLogListResponseItem as $h_Lapp_api_DocumentsAuditLogListResponseItem };
$h_Lapp_api_DocumentsAuditLogListResponseItem.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentsAuditLogListResponseItem)) {
    var x = this.Xk;
    var x$2 = x$0.Xk;
    if ((((x === null) ? (x$2 === null) : x.f(x$2)) && (this.Kt === x$0.Kt))) {
      var x$3 = this.Xl;
      var x$4 = x$0.Xl;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.EO;
      var x$6 = x$0.EO;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Ks;
      var x$8 = x$0.Ks;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 5;
});
$p.t = (function() {
  return "DocumentsAuditLogListResponseItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Xk;
      break;
    }
    case 1: {
      return this.Kt;
      break;
    }
    case 2: {
      return this.Xl;
      break;
    }
    case 3: {
      return this.EO;
      break;
    }
    case 4: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Ks);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "organizationId";
      break;
    }
    case 1: {
      return "organization";
      break;
    }
    case 2: {
      return "user";
      break;
    }
    case 3: {
      return "action";
      break;
    }
    case 4: {
      return "at";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DocumentsAuditLogListResponseItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ip)));
}
export { $isArrayOf_Lapp_api_DocumentsAuditLogListResponseItem as $isArrayOf_Lapp_api_DocumentsAuditLogListResponseItem };
var $d_Lapp_api_DocumentsAuditLogListResponseItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentsAuditLogListResponseItem, "app.api.DocumentsAuditLogListResponseItem", ({
  ip: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentsAuditLogListResponseItem as $d_Lapp_api_DocumentsAuditLogListResponseItem };
//# sourceMappingURL=app.api.-Documents-Audit-Log-List-Response-Item.js.map
